export const FEEDBACK_SORT_FIELDS = ['id', 'username', 'rating', 'createAt', 'updateAt'] as const;
export type FeedbackSortField = typeof FEEDBACK_SORT_FIELDS[number];

export interface Feedback {
  id: number;
  productId: number;
  username: string | null;
  comment: string | null;
  rating: number | null;
  createAt: string | null;
  updateAt: string | null;
}

export interface FeedbackPage {
  currentPage: number;
  totalPages: number;
  pageSize: number;
  totalElements: number;
  data: Feedback[];
}

export interface FeedbackQuery {
  page: number;
  size: number;
  sort: FeedbackSortField;
}

export interface UpdateFeedbackInput {
  comment?: string;
  rating?: number;
}
